import html from "../assets/svg/skill-icons/icons8-html.svg";
import css from "../assets/svg/skill-icons/icons8-css.svg";
import javascript from "../assets/svg/skill-icons/icons8-javascript.svg";
import bootstrap from "../assets/svg/skill-icons/icons8-bootstrap.svg";
import react from "../assets/svg/skill-icons/icons8-react-js.svg";
import php from "../assets/svg/skill-icons/icons8-php.svg";
import tailwind from "../assets/svg/skill-icons/icons8-tailwind-css.svg";
import laravel from "../assets/svg/skill-icons/icons8-laravel.svg";
import nextjs from "../assets/svg/skill-icons/icons8-next.js.svg";

const skill = [
  {
    icon: html,
    title: "HTML5 (Hyper Text Markup Language)",
    des: "The core language for structuring content on the web, providing the essential building blocks for web pages like text, images, and links.",
  },
  {
    icon: css,
    title: "CSS3 (Cascading Style Sheet)",
    des: "Used to style and format the layout of web pages, CSS defines visual aspects such as colors, fonts, spacing, and responsiveness.",
  },
  {
    icon: javascript,
    title: "JavaScript",
    des: "A versatile programming language that enables interactive functionality on web pages, such as form validation, dynamic content updates, and animations.",
  },
  {
    icon: bootstrap,
    title: "Bootstrap",
    des: "A popular front-end framework that provides pre-built CSS and JavaScript components to create responsive, mobile-first websites quickly.",
  },
  {
    icon: react,
    title: "React.js",
    des: "A popular JavaScript library for building user interfaces. It's developed and maintained by Facebook and a community of developers.",
  },
  {
    icon: nextjs,
    title: "Next.js",
    des: "A powerful open-source React framework created by Vercel that allows developers to build full-stack web applications",
  },
  {
    icon: php,
    title: "PHP (Hypertext Preprocessor)",
    des: "A widely-used, open-source scripting language primarily designed for web development.",
  },
  {
    icon: tailwind,
    title: "Tailwind CSS",
    des: "Tailwind CSS is a utility-first CSS framework that simplifies web design for beginners and experienced developers alike.",
  },
  {
    icon: laravel,
    title: "Laravel",
    des: "For building web applications.It's designed to simplify common web development tasks and is based on the model–view–controller (MVC) architectural pattern.",
  },
];

export { skill };
